// https://github.com/pillarjs/path-to-regexp#readme
import { match } from 'path-to-regexp';

import { Language } from '@rover/constants/src/i18n/lingui.constants';
import type { Locality } from '@rover/types/src/Locality';
import { Http404Error } from '@rover/utilities/HttpError';
import {
  CountryUrlPrefix,
  getShortLanguagesByUrlPrefix,
} from '@rover/utilities/roverGeo.constants';

const LOCALITY_URLPATTERN = '/:country{/:language}?/:region/:city?/:neighborhood?/';

const parsePath = match<Locality>(LOCALITY_URLPATTERN);

export const pathToLocality = (path: string): Locality => {
  const output = parsePath(path.split('?')[0]);
  if (!output) throw new Http404Error(`Unable to convert path "${path}" to Locality.`);
  const locality = output.params;
  if (locality.language === undefined) return locality;
  if (
    getShortLanguagesByUrlPrefix(locality.country as CountryUrlPrefix).includes(
      locality.language as Language
    )
  ) {
    return locality;
  }
  const { country, language, region, city } = locality;
  return { country, language: undefined, region: language!, city: region, neighborhood: city };
};
